import { SvgIcon } from '@mui/material';

import { ModifiedMuiIconProps } from '../../interfaces';

const CheckCircleIcon: React.FC<ModifiedMuiIconProps> = ({
  color,
  backgroundColor,
  ...rest
}) => {
  return (
    <SvgIcon
      className="MuiSvgIcon-root MuiSvgIcon-fontSizeMedium MuiStepIcon-root Mui-completed css-145jw49-MuiSvgIcon-root-MuiStepIcon-root"
      focusable="false"
      aria-hidden="true"
      viewBox="0 0 24 24"
      {...rest}
    >
      <path
        d="M 11.5 0.7 a 10.8 10.8 90 1 0 0 21.6 a 10.8 10.8 90 0 0 0 -21.6 z"
        fill={backgroundColor}
      ></path>
      <path
        d="M12 0a12 12 0 1 0 0 24 12 12 0 0 0 0-24zm-2 17l-5-5 1.4-1.4 3.6 3.6 7.6-7.6L19 8l-9 9z"
        fill={color}
      ></path>
    </SvgIcon>
  );
};

export default CheckCircleIcon;
